
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ee-workspace-service-delivery",
      function () {
        return require("private-next-pages/solutions/ee-workspace-service-delivery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/ee-workspace-service-delivery"])
      });
    }
  